import {Component, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {AjaxService} from '../../../../services/ajax.service';
import {IDokumentItemViewModel} from '../../dokumente/dokument.model';
import {IDefaultSelectBoxViewModel} from '../../models/default-selectBox.model';
import {DxFormComponent} from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';
import {Data} from '@angular/router';

interface IAusnahmeInitResponse {
  ue: IAusnahmeInitUeResponse;

  available_Verwaltungsgerichte: IDefaultSelectBoxViewModel[];
}

interface IAusnahmeInitUeResponse {
  ueId: number;
  ueberbelegungId?: number;

  verwaltungsgerichtId?: number;
  von?: Date;
  bis?: Date;

  bemerkung: string;
}

@Component({
    selector: 'cz-ausnahme',
    templateUrl: './ausnahme.component.html',
    styleUrls: ['./ausnahme.component.css'],
    standalone: false
})
export class AusnahmeComponent implements OnInit {
  @ViewChild('form1', {static: false}) form1: DxFormComponent;

  @Input() events: Observable<any>;
  @Input() eId: number;
  @Input() optional: any;

  @Output() onCloseOk: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotValid: EventEmitter<any> = new EventEmitter<any>();

  eventsSubscription: any;
  loading: number = 1;

  init_data: IAusnahmeInitResponse = {} as IAusnahmeInitResponse;

  _nowDate: Date;
  get nowDate(): Date {
    if (!this._nowDate) {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      this._nowDate = d;
    }

    return this._nowDate;
  }
  minDate = new Date('1900/1/1');
  maxDate = new Date('2099/12/31');

  dateValidationCallback(e) {
    const date = new Date(e.value);
    return date >= e.rule.min && date <= e.rule.max;
  }

  constructor(private ajaxService: AjaxService) {
    this.dateValidationCallback = this.dateValidationCallback.bind(this);
  }

  ngOnInit() {
    this.eventsSubscription = this.events.subscribe((event) => this.onEvent(event));

    this.load(() => {
      this.setOptional();
    });
  }

  setOptional() {
    if (this.optional) {
      if (this.optional.ueberbelegungId) {
        this.init_data.ue.ueberbelegungId = this.optional.ueberbelegungId;
      }

      if (this.optional.von) {
        this.init_data.ue.von = this.optional.von;
      }

      if (this.optional.bis) {
        this.init_data.ue.bis = this.optional.bis;
      }
    }
  }

  load(cb: () => void = null) {
    this.startLoading(1);

    this.ajaxService.post<IAusnahmeInitResponse>('api/Ausnahme/GetInit', {eId: this.eId}).subscribe({
      next: (response) => {
        this.init_data = response;
        if (cb) {
          cb();
        }

        this.stopLoading();
      },
      error: (e) => {
        this.stopLoading();
        throw e;
      },
    });
  }

  onEvent(event) {
    if (event === 'Save') {
      this.save();
    }
  }

  // #region Save
  save() {
    if (this.isValid()) {
      this.startLoading(2);
      this.ajaxService.post<IDokumentItemViewModel>('api/Ausnahme/BuildAusnahme', this.init_data.ue).subscribe({
        next: (response) => {
          // if (response) {
          // const re = /\./gi;
          // const fileName = new Date().toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(re, '-') + '_Betriebserlaubnis.docx';
          // this.ajaxService.download('/api/Dokument/Download?fileName=' + response.name + '&dokumentName=' + response.bezeichnung, fileName, () => {
          this.stopLoading();
          this.onCloseOk.emit(true);
          // });
          // }
        },
        error: (e) => {
          this.stopLoading();
          throw e;
        },
      });
    } else {
      this.onNotValid.next(false);
    }
  }

  isValid(withMsg: boolean = true): boolean {
    if (this.form1) {
      const validationResult = this.form1.instance.validate();
      if (!validationResult.isValid) {
        if (withMsg) {
          let msg = '';
          for (const err of validationResult.brokenRules) {
            msg += err.message + '\r\n';
          }

          notify(
            {
              message: msg,
              width: 600,
            },
            'error',
            3000
          );
        }

        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  // #endregion

  startLoading(state: number) {
    this.loading = state;
  }

  stopLoading() {
    this.loading = 0;
  }
}
